import { useTour } from './TourContext';

/* The "?" that opens the tour at one feature.
 *
 * ── Why it exists ──
 * The tour runs to dozens of steps. Somebody who cannot work out what the red banner is does not
 * want to start at "Welcome to Real or Fake" and press Next thirty times, and forcing that is how
 * a tour becomes something nobody opens twice. This starts at the thing you are looking at and
 * stops at the end of its chapter.
 *
 * The same ids work as a URL — `…/real-or-fake/endless?tour=readiness` — so an answer can be
 * pasted into Slack rather than described. Both routes resolve through stepsFrom, so a link and
 * a click always land in the same place.
 *
 * Deliberately quiet: a "?" in the muted text colour, not a badge and not a coloured dot. It sits
 * beside working controls all day and must not compete with them.
 */
export default function TourLink({ to, label }: { to: string; label: string }) {
  const { open } = useTour();
  return (
    <button
      type="button"
      className="tour-link"
      /* The label says what it explains, because "?" alone tells a screen reader nothing and
         tells a hurried reader only slightly more. */
      title={`Show me: ${label}`}
      aria-label={`Show me how ${label} works`}
      data-tour-link={to}
      onClick={(e) => {
        // Inside clickable rows in places; opening the tour must not also trigger the row.
        e.stopPropagation();
        open(to);
      }}
    >
      ?
    </button>
  );
}
